import { GrGithub } from "react-icons/gr";
import { IoMegaphone } from "react-icons/io5";
import { Button } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  GrGithub,
  IoMegaphone,
  Button,
  React
};